import React, { useEffect } from 'react';
import { X, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../mock';

const SideMenu = ({ open, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/60 z-40 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={onClose}
      />
      <aside
        className={`fixed top-0 left-0 h-full w-[300px] bg-white z-50 shadow-2xl transform transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <span className="font-black tracking-[0.15em] text-lg text-gray-900" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>BCOOLSTORE</span>
          <button onClick={onClose} aria-label="Fermer le menu" className="text-gray-700 hover:text-[#8b2c3f] transition-colors"><X size={20} /></button>
        </div>
        <nav className="px-5 py-4">
          <ul className="space-y-1">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  onClick={onClose}
                  to={c.slug === 'home' ? '/' : `/category/${c.slug}`}
                  className="block py-2.5 text-[13px] font-bold uppercase tracking-wider text-gray-800 hover:text-[#8b2c3f] transition-colors border-b border-gray-100"
                >{c.name}</Link>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex items-center gap-4">
            <a href="#" className="text-gray-700 hover:text-[#8b2c3f] transition-colors"><Facebook size={17} /></a>
            <a href="#" className="text-gray-700 hover:text-[#8b2c3f] transition-colors"><Twitter size={17} /></a>
            <a href="#" className="text-gray-700 hover:text-[#8b2c3f] transition-colors"><Instagram size={17} /></a>
            <a href="#" className="text-gray-700 hover:text-[#8b2c3f] transition-colors"><Youtube size={19} /></a>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default SideMenu;
